<template>
  <div>
    <Row type="flex" justify="center">
      <Col>
        <h3
          style="color:#893448;font-size:18px;letter-spacing:0.4px;white-space: nowrap;"
        >{{ table_title }}
        </h3>
      </Col>
    </Row>
    <Row>
      <Col span="24">
        <Tabs :value="this.current_tabs_name" type="card" @on-click="current_tabs_click" name="tab1">
          <TabPane :label="tabs_label1" name="name1" tab="tab1">
            <v-table
              :title="this.current_strategy_title"
              :title_info="this.current_strategy_info"
              :table_columns="this.current_strategy_columns"
              :table_data="this.current_strategy_data"
              :table_ref="this.current_strategy_ref"
              :max_height="250"
              :init_table="this.current_strategy_init_table_func"
              :table_name_array="this.current_strategy_array"
              :show_top="false"
              :show_page="false"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_label2" name="name2" tab="tab1">
            <v-table
              :title="this.historical_strategy_title"
              :title_info="this.historical_strategy_info"
              :table_columns="this.historical_strategy_columns"
              :table_data="this.historical_strategy_data"
              :table_ref="this.historical_strategy_ref"
              :max_height="250"
              :init_table="this.historical_strategy_init_table_func"
              :table_name_array="this.historical_strategy_array"
              :show_top="false"
              :show_page="false"
            ></v-table>
          </TabPane>
          <TabPane :label="tabs_label3" name="name3" tab="tab1">
            <div>
            <Row type="flex" justify="center">
              <Col>
                <h3
                  style="color:#893448;font-size:13px;letter-spacing:0.4px;white-space:nowrap;"
                >{{ create_or_alter_table_title }}
                </h3>
              </Col>
            </Row>
              <Row>
                <Col>
                  <v-flexible-render-modal-view
                      :paras='modal_view_msg["paras"]'
                      :open_modal_switch='modal_view_msg["open_modal_switch"]'
                      :uuid='modal_view_msg["uuid"]'
                      :name='modal_view_msg["name"]'
                      :modal_type='modal_view_msg["m_type"]'
                      :open_or_close='modal_view_msg["open_or_close"]'
                      :execute_percent='modal_view_msg["execute_percent"]'
                      v-on:modal_click="modal_click"
                    >
                  </v-flexible-render-modal-view>
                  <Tabs :value="create_or_alter_table_current_tabs_name" type="card" name="tab2">
                    <TabPane label="开仓信号" name="create_name1" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="sign"
                              open_or_close="open"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                        <v-table
                          :title="this.create_or_alter_table_name1_title"
                          :title_info="this.create_or_alter_table_name1_info"
                          :table_columns="this.create_or_alter_table_name1_columns"
                          :table_data="this.create_or_alter_table_name1_data"
                          :table_ref="this.create_or_alter_table_name1_ref"
                          :max_height="250"
                          :init_table="this.create_or_alter_table_name1_init_table_func"
                          :table_name_array="this.create_or_alter_table_name1_array"
                          :show_top="false"
                          :show_page="false"
                        ></v-table>
                    </TabPane>
                    <TabPane label="平仓信号" name="create_name2" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="sign"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name2_title"
                          :title_info="this.create_or_alter_table_name2_info"
                          :table_columns="this.create_or_alter_table_name2_columns"
                          :table_data="this.create_or_alter_table_name2_data"
                          :table_ref="this.create_or_alter_table_name2_ref"
                          :max_height="250"
                          :init_table="this.create_or_alter_table_name2_init_table_func"
                          :table_name_array="this.create_or_alter_table_name2_array"
                          :show_top="false"
                          :show_page="false"
                        ></v-table>
                    </TabPane>
                    <TabPane label="止盈/止损设置" name="create_name3" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="default"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name3_title"
                          :title_info="this.create_or_alter_table_name3_info"
                          :table_columns="this.create_or_alter_table_name3_columns"
                          :table_data="this.create_or_alter_table_name3_data"
                          :table_ref="this.create_or_alter_table_name3_ref"
                          :max_height="250"
                          :init_table="this.create_or_alter_table_name3_init_table_func"
                          :table_name_array="this.create_or_alter_table_name3_array"
                          :show_top="false"
                          :show_page="false"
                        ></v-table>
                    </TabPane>
                    <TabPane label="订单执行设置" name="create_name4" tab="tab2">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="function_type"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <v-table
                          :title="this.create_or_alter_table_name4_title"
                          :title_info="this.create_or_alter_table_name4_info"
                          :table_columns="this.create_or_alter_table_name4_columns"
                          :table_data="this.create_or_alter_table_name4_data"
                          :table_ref="this.create_or_alter_table_name4_ref"
                          :max_height="250"
                          :init_table="this.create_or_alter_table_name4_init_table_func"
                          :table_name_array="this.create_or_alter_table_name4_array"
                          :show_top="false"
                          :show_page="false"
                        ></v-table>
                    </TabPane>
                    <TabPane label="绑定账户设置" name="create_name5" tab="tab2" :disabled="create_or_alter_table_disabled">
                      <Row>
                        <Col span="4" offset="20">
                            <v-flexible-render-dropdown-view
                              :allow_msg="this.allow_msg"
                              m_type="account_msg"
                              open_or_close="close"
                              v-on:dropdown_click="flexible_render_dropdown_click"
                            ></v-flexible-render-dropdown-view>
                        </Col>
                      </Row>
                      <Row style="height:5px;"></Row>
                      <div style="min-height:250px;">
                      <v-table
                          :title="this.create_or_alter_table_name5_title"
                          :title_info="this.create_or_alter_table_name5_info"
                          :table_columns="this.create_or_alter_table_name5_columns"
                          :table_data="this.create_or_alter_table_name5_data"
                          :table_ref="this.create_or_alter_table_name5_ref"
                          :max_height="250"
                          :init_table="this.create_or_alter_table_name5_init_table_func"
                          :table_name_array="this.create_or_alter_table_name5_array"
                          :show_top="false"
                          :show_page="false"
                        ></v-table>
                      </div>
                    </TabPane>
                  </Tabs>
                </Col>
              </Row>
              <Row style="height:15px;"></Row>
              <Row type="flex" justify="space-around" align="bottom">
                <Col offset="12">
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_1">录入ID</Button>
                </Col>
                <Col>
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_2">{{create_or_alter_table_button_title}}</Button>
                </Col>
                <Col>
                  <Button type="success" shape="circle" size="large" @click="create_or_alter_table_click_3">重置参数</Button>
                </Col>
                <Col span="1">
                </Col>
              </Row>
            </div>
          </TabPane>
          <TabPane :label="tabs_label4" name="name4" tab="tab1">
            <Row type="flex" justify="center" align="middle">
              <Col offset="20">
                  <v-flexible-render-dropdown-view
                    :allow_msg="this.all_strategy"
                    m_type="strategy_msg"
                    :drop_down_title="this.supervisor_strategy_drop_down_title"
                    v-on:dropdown_click="flexible_render_dropdown_click"
                    :icon_flag="false"
                  ></v-flexible-render-dropdown-view>
              </Col>
              <Col>
                <Button style="font-size:20px;color:#0099FF;box-shadow:none" type="text" size="large" 
                  shape="circle" icon="md-refresh" :loading="this.loop_update_supervisor_button_loading"
                  @click="this.loop_update_supervisor_button_click"
                  ></Button>
              </Col>
            </Row>
            <v-table
              :title="this.supervisor_strategy_title"
              :title_info="this.supervisor_strategy_info"
              :table_columns="this.supervisor_strategy_columns"
              :table_data="this.supervisor_strategy_data"
              :table_ref="this.supervisor_strategy_ref"
              :max_height="250"
              :init_table="this.supervisor_strategy_init_table_func"
              :table_name_array="this.supervisor_strategy_array"
              :show_top="false"
              :show_page="false"
            ></v-table>
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  </div>
</template>

<script>
import store from '../store'
import table_view from "../components/TableView.vue";
import flexible_render_table_view from "../components/FlexibleStrategy/TableRenderSign.vue";
import flexible_render_modal_view from "../components/FlexibleStrategy/ModalRenderSign.vue";
import flexible_render_dropdown_view from "../components/FlexibleStrategy/DropdownRender.vue";

export default {
  name: "flexible_strategy",
  components: {
     "v-table": table_view,
     "v-flexible-render-table-view": flexible_render_table_view,
     "v-flexible-render-modal-view": flexible_render_modal_view,
     "v-flexible-render-dropdown-view":flexible_render_dropdown_view,
  },
  data() {
    return {
      table_title:"灵活策略运行管理",
      create_or_alter_table_title:"创建新策略",
      create_or_alter_table_button_title:"确认创建",
      create_or_alter_table_disabled:false,
      current_tabs_name:"name1",
      loop_update_supervisor_strategy_time_count:5,
      loop_update_supervisor_button_loading:false,
      create_or_alter_table_current_tabs_name:"create_name1",
      tabs_label1:"当前策略",
      tabs_label2:"历史策略",
      tabs_label3:"创建/修改",
      tabs_label4:"策略监控",

      // 展示在创建/修改页面上策略信息
      // 关键项参数，会频繁变化
      create_or_alter_table_msg:[],
      // 循环执行
      timer: null,
      // 控制策略允许添加的各项参数
      allow_msg:null,
      // 控制策略允许添加的所有策略信息
      all_strategy:null,
      // 控制账户允许操作的策略列表
      strategy_msg:null,
      // 用户当前选择的用以修改的策略ID
      create_or_alter_table_strategy_id:"-1",
      // 用户当前选择的需要监控执行进度的策略ID
      supervisor_strategy_id:"-1",
      // 特殊的UUID，用以同时控制所有account的开仓比例
      default_control_name5_uuid:"default_control_name5",
      supervisor_strategy_drop_down_title:"选择一个策略",
      // 初始化modal的变量
      modal_view_msg:{
        "paras":[],
        "open_modal_switch":false,
        "open_or_close":"open",
        "uuid":"",
        "sign_name":"",
        "execute_percent":1
      },
      
      current_strategy_title: "",
      current_strategy_info: [],
      current_strategy_columns: [],
      current_strategy_data: [],
      current_strategy_ref: "current_strategy_ref",
      current_strategy_array: [
        "策略ID",
        "名称",
        "描述",
        "参数",
        "标的",
        "运行操作",
        "其他操作"
      ],

      historical_strategy_title: "",
      historical_strategy_info: [],
      historical_strategy_columns: [],
      historical_strategy_data: [],
      historical_strategy_ref: "historical_strategy_ref",
      historical_strategy_array: [
        "策略ID",
        "名称",
        "描述",
        "参数",
        "标的",
        "运行操作",
        "其他操作"
      ],

      supervisor_strategy_title: "",
      supervisor_strategy_info: [],
      supervisor_strategy_columns: [],
      supervisor_strategy_data: [],
      supervisor_strategy_ref: "supervisor_strategy_ref",
      supervisor_strategy_array: [
        "账户编号",
        "方向",
        "数量",
        "下单标的",
        "成本价",
        "现价",
        "止盈价",
        "止损价",
        "信息",
        "未实现盈亏",
        "执行进度",
      ],

      create_or_alter_table_name1_title: "",
      create_or_alter_table_name1_info: [],
      create_or_alter_table_name1_columns: [],
      create_or_alter_table_name1_data: [],
      create_or_alter_table_name1_ref: "create_or_alter_table_name1_ref",
      create_or_alter_table_name1_array: [
        "信号ID",
        "信号名称",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name2_title: "",
      create_or_alter_table_name2_info: [],
      create_or_alter_table_name2_columns: [],
      create_or_alter_table_name2_data: [],
      create_or_alter_table_name2_ref: "create_or_alter_table_name2_ref",
      create_or_alter_table_name2_array: [
        "信号ID",
        "信号名称",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name3_title: "",
      create_or_alter_table_name3_info: [],
      create_or_alter_table_name3_columns: [],
      create_or_alter_table_name3_data: [],
      create_or_alter_table_name3_ref: "create_or_alter_table_name3_ref",
      create_or_alter_table_name3_array: [
        "信号ID",
        "信号名称",
        "信号参数",
        "执行效率",
        "操作"
      ],

      create_or_alter_table_name4_title: "",
      create_or_alter_table_name4_info: [],
      create_or_alter_table_name4_columns: [],
      create_or_alter_table_name4_data: [],
      create_or_alter_table_name4_ref: "create_or_alter_table_name4_ref",
      create_or_alter_table_name4_array: [
        "信号ID",
        "开仓/平仓阶段",
        "信号参数",
        "操作"
      ],

      create_or_alter_table_name5_title: "",
      create_or_alter_table_name5_info: [],
      create_or_alter_table_name5_columns: [],
      create_or_alter_table_name5_data: [],
      create_or_alter_table_name5_ref: "create_or_alter_table_name5_ref",
      create_or_alter_table_name5_array: [
        "uuid",
        "账户编号",
        "账户说明",
        "开仓比例",
        "操作"
      ],
    };
  },
  methods: {
    flexible_render_dropdown_click: function(value) {
      if (value["mode"] != "ok") {
        console.log("Wrong mode")
        return null
      }
      if (value["m_type"] === "account_msg" && value["paras"][0] === "all") {
        // 用户单击了添加所有账户按钮
        for (var i = 0; i < this.allow_msg["account_msg"].length; i++) {
          this.create_or_alter_table_msg.push({
            "type":value["m_type"],
            "name":value["name"],
            "paras":[this.allow_msg["account_msg"][i][0], 1],
            "open_or_close":value["open_or_close"],
            "execute_percent":1,
            "description":this.allow_msg["account_msg"][i][1],
            "uuid":this.get_uuid()
          })
        }
      } else if (value["m_type"] === "strategy_msg") {
        this.supervisor_strategy_id = value["paras"][0]
      } else {
        this.create_or_alter_table_msg.push({
          "type":value["m_type"],
          "name":value["name"],
          "paras":value["paras"],
          "open_or_close":value["open_or_close"],
          "execute_percent":1,
          "description":value["description"],
          "uuid":this.get_uuid()
        })
      }
      // 重新渲染表格
      this.update_create_or_alter_table_msg()
    },
    current_tabs_click: function(name) {
      this.current_tabs_name = name
      //用户单击了当前策略/历史策略/修改策略中的某一个
      if (name === "name3") {
        if (this.create_or_alter_table_strategy_id === "-1") {
          this.create_or_alter_table_click_3()
        }
      }
    },
    get_paras_msg: function(strategy_con) {
      // 根据策略的各项信号，返回一个可以给前端展示的长字符串
      // 用来快速概览策略的参数
      var open_paras_list = []
      var close_paras_list = []
      var function_type_list = []
      var default_list = []
      for(var index in strategy_con) {
        var msg = strategy_con[index]
        // 填充创建/修改页签下的数据
        if (msg["type"] === "sign" && msg["open_or_close"] === "open") {
          open_paras_list.push([
            msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "sign" && msg["open_or_close"] === "close") {
          close_paras_list.push([
           msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "default") {
          default_list.push([
            msg["name"], msg["paras"]
          ])
        } else if (msg["type"] === "function_type") {
          function_type_list.push([
            msg["open_or_close"], msg["paras"]
          ])
        }
      }
      var res = ""
      res += "开仓参数:\n\t"
      for (var i = 0; i < open_paras_list.length; i++) {
        res += open_paras_list[i][0] + " " + open_paras_list[i][1] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "平仓参数:\n\t"
      for (var i = 0; i < close_paras_list.length; i++) {
        res += close_paras_list[i][0] + " " + close_paras_list[i][1] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "固定参数:\n\t"
      for (var i = 0; i < default_list.length; i++) {
        res += default_list[i][0] + " " + default_list[i][1] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      res += "订单执行参数:\n\t"
      var function_type_index = store.state.function_type_index
      for (var i = 0; i < function_type_list.length; i++) {
        res += function_type_list[i][0] + " " + function_type_index[function_type_list[i][1]] + "\n\t"
      }
      res = res.substring(0, res.length - 1)
      return res
    },
    get_strategy_msg: function(strategy_con) {
      // 对选择策略信息筛选，返回策略本身的内容
      for(var index in strategy_con) {
        var msg = strategy_con[index]
        if (msg["type"] === "strategy_msg") {
          // 当策略处于正在运行状态时，不允许更新绑定账户页签
          return msg
        }
      }
      return null
    },
    update_strategy_table_msg: function() {
      // 清空之前已经填充的数据
      this.current_strategy_data = []
      this.historical_strategy_data = []
      // 根据all_strategy数据, 将数据更新到当前策略页面+历史策略页面上
      for(var str_id in this.all_strategy) {
        if (str_id.toString() === "-1") {
            continue
        }
        let strategy_con = this.all_strategy[str_id]
        let paras_msg = this.get_paras_msg(strategy_con)
        let strategy_msg = this.get_strategy_msg(strategy_con)["paras"]
        if (["0", "1"].indexOf(strategy_msg["current_status_code"].toString()) != -1) {
          this.current_strategy_data.push([
            str_id, strategy_msg["name"], strategy_msg["description"], paras_msg, 
            strategy_msg["current_symbol"], strategy_msg["current_status_code"], ""
          ])
        } else if(["2"].indexOf(strategy_msg["current_status_code"].toString()) != -1) {
          this.historical_strategy_data.push([
            str_id, strategy_msg["name"], strategy_msg["description"], paras_msg, 
            strategy_msg["current_symbol"], strategy_msg["current_status_code"], ""
          ])
        }
      }
    },
    update_supervisor_strategy_table_msg: function() {
      var msg = this.supervisor_strategy_get_msg()
      // 清空之前已经填充的数据
      this.supervisor_strategy_data = []
      // 根据supervisor_strategy_get_msg接口的数据, 将数据更新到监控上
      if (this.supervisor_strategy_id.toString() == "-1") {
        return []
      }
      for (var i = 0; i < msg.length; i++) {
        this.supervisor_strategy_data.push(msg[i])
      }
    },
    update_create_or_alter_table_msg: function() {
      this.create_or_alter_table_disabled = false
      this.create_or_alter_table_msg = 
        this.check_account_msg(this.create_or_alter_table_msg)
      // 将存储的create_or_alter_table_msg数据刷新到表格内
      // 清空之前已经填充的数据
      this.create_or_alter_table_name1_data = []
      this.create_or_alter_table_name2_data = []
      this.create_or_alter_table_name3_data = []
      this.create_or_alter_table_name4_data = []
      this.create_or_alter_table_name5_data = []
      //填充各个子页面的数据
      for(var index in this.create_or_alter_table_msg) {
        var msg = this.create_or_alter_table_msg[index]
        // 填充创建/修改页签下的数据
        if (msg["type"] === "sign" && msg["open_or_close"] === "open") {
          this.create_or_alter_table_name1_data.push([
            msg["uuid"], msg["name"], msg["paras"], msg["execute_percent"], ""
          ])
        } else if (msg["type"] === "sign" && msg["open_or_close"] === "close") {
          this.create_or_alter_table_name2_data.push([
            msg["uuid"], msg["name"], msg["paras"], msg["execute_percent"], ""
          ])
        } else if (msg["type"] === "default") {
          this.create_or_alter_table_name3_data.push([
            msg["uuid"], msg["name"], msg["paras"], msg["execute_percent"], ""
          ])
        } else if (msg["type"] === "function_type") {
          this.create_or_alter_table_name4_data.push([
            msg["uuid"], msg["open_or_close"], msg["paras"], ""
          ])
        } else if (msg["type"] === "account_msg") {
          this.create_or_alter_table_name5_data.push([
            msg["uuid"], msg["paras"][0], msg["description"], msg["paras"][1], ""
          ])
          this.create_or_alter_table_name5_data.sort(function(a, b){return a[1] - b[1]})
        } else if (msg["type"] === "strategy_msg" && msg["paras"]["current_status_code"].toString() == "1") {
          // 当策略处于正在运行状态时，不允许更新绑定账户页签
          this.create_or_alter_table_disabled = true
        }
      }
      // 额外添加一个总控，用以同时调整所有账户的下单比例
      if (this.create_or_alter_table_name5_data.length == 0) {
        this.create_or_alter_table_name5_data.push([
          this.default_control_name5_uuid, "", "", 1, ""
        ])
      } else {
        this.create_or_alter_table_name5_data.push([
          this.default_control_name5_uuid, "", "", this.create_or_alter_table_name5_data[0][3], ""
        ])
      }
    },
    create_or_alter_table_click_1: function() {
      // 单击了录入ID按钮
      this.modal_view_msg["uuid"] = this.create_or_alter_table_strategy_id
      this.modal_view_msg["name"] = ""
      this.modal_view_msg["m_type"] = "select_strategy_msg"
      this.modal_view_msg["paras"] = JSON.parse(JSON.stringify(this.all_strategy))
      this.modal_view_msg["execute_percent"] = 1
      this.modal_view_msg["open_or_close"] = "close"
      this.modal_view_msg["open_modal_switch"] = true
    },
    create_or_alter_table_click_2: function() {
      // 单击了创建/修改按钮
      // 弹出最后几步修正项,
      // 打开指标设置页面modal
      var value = null
      let acc_count = 0
      for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["type"] === "strategy_msg") {
            value = JSON.parse(JSON.stringify(this.create_or_alter_table_msg[i]))
          } else if (this.create_or_alter_table_msg[i]["type"] === "account_msg") {
            acc_count += 1
          }
      }
      if (value === null) {
        console.log("Wrong create_or_alter_table_msg")
        return null
      }
      let paras = value["paras"]
      paras["acc_count"] = acc_count
      paras["create_or_alter_table_disabled"] = this.create_or_alter_table_disabled
      this.modal_view_msg["uuid"] = this.create_or_alter_table_strategy_id
      this.modal_view_msg["name"] = ""
      this.modal_view_msg["m_type"] = "strategy_msg"
      this.modal_view_msg["paras"] = paras
      this.modal_view_msg["execute_percent"] = 1
      this.modal_view_msg["open_or_close"] = "close"
      this.modal_view_msg["open_modal_switch"] = true
    },
    create_or_alter_table_click_3: function() {
      // 单击了重置按钮
      // 重新加载参数
      this.create_or_alter_table_msg = 
        this.create_or_alter_table_get_strategy_msg(this.create_or_alter_table_strategy_id)
      this.update_create_or_alter_table_msg()
    },
    create_or_alter_table_name1_init_table_func: function() {
      // 初始化创建/修改策略标签页内的开仓表格
      const name_array = this.create_or_alter_table_name1_array;
      this.create_or_alter_table_name1_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name1_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name1_columns[0]["width"] = 100;
      this.create_or_alter_table_name1_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name1_columns[4]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name1_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "sign"
                  this.modal_view_msg["paras"] = value[2]
                  this.modal_view_msg["execute_percent"] = value[3]
                  this.modal_view_msg["open_or_close"] = "open"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var uuid = this.create_or_alter_table_name1_data[params["index"]][0]
                  // 根据UUID删除该项，之后更新table
                  for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                    if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                        this.create_or_alter_table_msg.splice(i, 1)
                        break
                    }
                  }
                  this.update_create_or_alter_table_msg()
                }
              }
            },
            "删除"
          )
        ]);
      };
    },
    create_or_alter_table_name2_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name2_array;
      this.create_or_alter_table_name2_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name2_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name2_columns[0]["width"] = 100;
      this.create_or_alter_table_name2_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name2_columns[4]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name2_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "sign"
                  this.modal_view_msg["paras"] = value[2]
                  this.modal_view_msg["execute_percent"] = value[3]
                  this.modal_view_msg["open_or_close"] = "close"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var uuid = this.create_or_alter_table_name2_data[params["index"]][0]
                  // 根据UUID删除该项，之后更新table
                  for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                    if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                        this.create_or_alter_table_msg.splice(i, 1)
                        break
                    }
                  }
                  this.update_create_or_alter_table_msg()
                }
              }
            },
            "删除"
          )
        ]);
      };
    },
    create_or_alter_table_name3_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name3_array;
      this.create_or_alter_table_name3_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name3_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name3_columns[0]["width"] = 100;
      this.create_or_alter_table_name3_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name3_columns[4]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name3_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = value[1]
                  this.modal_view_msg["m_type"] = "default"
                  this.modal_view_msg["paras"] = value[2]
                  this.modal_view_msg["execute_percent"] = value[3]
                  this.modal_view_msg["open_or_close"] = "close"
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var uuid = this.create_or_alter_table_name3_data[params["index"]][0]
                  // 根据UUID删除该项，之后更新table
                  for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                    if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                        this.create_or_alter_table_msg.splice(i, 1)
                        break
                    }
                  }
                  this.update_create_or_alter_table_msg()
                }
              }
            },
            "删除"
          )
        ]);
      };
    },
    create_or_alter_table_name4_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name4_array;
      this.create_or_alter_table_name4_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.create_or_alter_table_name4_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      this.create_or_alter_table_name4_columns[0]["width"] = 100;
      this.create_or_alter_table_name4_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name4_columns[1]["render"] = (h, params) => {
        var index = this.create_or_alter_table_name4_data[params["index"]][1]
        let value = null
        if (index === 'open') {value = "开仓阶段"}
        else if (index === 'close') {value = "平仓阶段"}
        else {value = "不识别的订单执行阶段"}

        return h("div", [
          this.$createElement(
            "span",
            {
              style: {
                marginRight: "5px"
              },
            },
            value
          )
        ]);
      }
      this.create_or_alter_table_name4_columns[2]["render"] = (h, params) => {
        var index = this.create_or_alter_table_name4_data[params["index"]][2][0]
        let value = null
        if (index === 0) {value = "市价"}
        else if (index === 1) {value = "限价追单"}
        else {value = "脉冲追单V1.0"}

        return h("div", [
          this.$createElement(
            "span",
            {
              style: {
                marginRight: "5px"
              },
            },
            value
          )
        ]);
      }
      this.create_or_alter_table_name4_columns[3]["render"] = (h, params) => {
        return h("div", [
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: () => {
                  var value = this.create_or_alter_table_name4_data[params["index"]]
                  // 打开指标设置页面modal
                  this.modal_view_msg["uuid"] = value[0]
                  this.modal_view_msg["name"] = ""
                  this.modal_view_msg["m_type"] = "function_type"
                  this.modal_view_msg["paras"] = value[2]
                  this.modal_view_msg["execute_percent"] = 1
                  this.modal_view_msg["open_or_close"] = value[1]
                  this.modal_view_msg["open_modal_switch"] = true
                }
              },
            },
            "设置"
          )
        ]);
      };
    },
    create_or_alter_table_name5_init_table_func: function() {
      // 初始化创建/修改策略标签页内的平仓表格
      const name_array = this.create_or_alter_table_name5_array;
      this.create_or_alter_table_name5_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        if (i === 0) {
          // 不显示UUID
          continue
        }
        this.create_or_alter_table_name5_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        });
      }
      // 账户编号、账户说明、开仓比例、操作
      this.create_or_alter_table_name5_columns[0]["width"] = 100;
      this.create_or_alter_table_name5_columns[0]["tooltip"] = true;
      this.create_or_alter_table_name5_columns[2]["render"] = (h, params) => {
        var name5_value = this.create_or_alter_table_name5_data[params["index"]]
        return h("div", [
          this.$createElement(
            "Slider",
            {
              props: {
                value:name5_value[3],
                step:0.01,
                max:1,
                min:0.01,
                "show-tip":"never",
                "show-input":true,
              },
              style: {
                marginRight: "5px"
              },
              on: {
                "on-change": (value) => {
                  if (name5_value[0] != this.default_control_name5_uuid) {
                    for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                      if (this.create_or_alter_table_msg[i]["uuid"] === name5_value[0] && 
                          this.create_or_alter_table_msg[i]["paras"][0] === name5_value[1] ) {
                          this.create_or_alter_table_msg[i]["paras"][1] = value
                          break
                      }
                    }
                  } else {
                    for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                      if (this.create_or_alter_table_msg[i]["uuid"] != name5_value[0]) {
                          this.create_or_alter_table_msg[i]["paras"][1] = value
                      }
                    }
                    // 重新渲染表格
                    this.update_create_or_alter_table_msg()
                  }
                }
              },
            },
          )
        ]);
      };
      this.create_or_alter_table_name5_columns[3]["render"] = (h, params) => {
        if (this.create_or_alter_table_name5_data[params["index"]][0] != this.default_control_name5_uuid) {
          return h("div", [
            this.$createElement(
              "Button",
              {
                props: {
                  type: "warning",
                  size: "small",
                  loading: false
                },
                style: {
                  marginRight: "5px"
                },
                on: {
                  click: () => {
                    var uuid = this.create_or_alter_table_name5_data[params["index"]][0]
                    // 根据UUID删除该项，之后更新table
                    for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
                      if (this.create_or_alter_table_msg[i]["uuid"] === uuid) {
                          this.create_or_alter_table_msg.splice(i, 1)
                          break
                      }
                    }
                    this.update_create_or_alter_table_msg()
                  }
                }
              },
              "删除"
            )
          ]);
        }
      };
    },
    current_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.current_strategy_array;
      this.current_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.current_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        })
      }
      // "策略ID","名称","描述","参数","运行操作","其他操作"
      this.current_strategy_columns[1]["tooltip"] = true;
      this.current_strategy_columns[2]["tooltip"] = true;
      this.current_strategy_columns[3]["tooltip"] = true;
      this.current_strategy_columns[5]["minWidth"] = 130;
      this.current_strategy_columns[5]["render"] = (h, params) => {
        var status_code = Number(this.current_strategy_data[params["index"]][5])
        var disabled_style = null
        // 0:待启动 1:正在运行 2:历史策略 3:已删除
        if (status_code == 0) {
          // 开启 设置 监控 关闭
          disabled_style = [false, false, false, true]
        } else if (status_code == 1) {
          disabled_style = [true, false, false, false]
        } else {
          disabled_style = [true, true, true, true]
        }
        return h("div", {
          style: {
              display: "flex",
              "justify-content": "space-around",
              "align-items": "center"
          }
        },[
          this.$createElement(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
                loading: false,
                disabled: disabled_style[0]
              },
              style: {
              },
              on: {
                click: () => {
                  
                }
              },
            },
            "开启"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[1]
              },
              style: {
              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.current_strategy_data[params["index"]][0]
                  this.current_tabs_name = "name3"
                }
              }
            },
            "设置"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
                disabled: disabled_style[2]
              },
              style: {
              },
              on: {
                click: () => {
                  this.supervisor_strategy_id = this.current_strategy_data[params["index"]][0]
                  this.current_tabs_name = "name4"
                }
              }
            },
            "监控"
          ),
          this.$createElement(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                loading: false,
                disabled: disabled_style[3]
              },
              style: {
              },
              on: {
                click: () => {
                  
                }
              }
            },
            "关闭"
          ),
        ]);
      };
      this.current_strategy_columns[6]["render"] = (h, params) => {
        var status_code = Number(this.current_strategy_data[params["index"]][5])
        var disabled_style = null
        // 0:待启动 1:正在运行 2:历史策略 3:已删除
        if (status_code == 1) {
          // 开启 设置 监控 关闭
          disabled_style = true
        } else {
          disabled_style = false
        }
        return h("div",[
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-trash",
                disabled: disabled_style
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: () => {
                  // 将当前策略移植到历史策略页面中
                  var index = Number(this.current_strategy_data[params["index"]][0])
                }
              },
            }
          )
        ]);
      };
    },
    historical_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.historical_strategy_array;
      this.historical_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.historical_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          align: "center"
        })
      }
      // "策略ID","名称","描述","参数","运行操作","其他操作"
      this.historical_strategy_columns[1]["tooltip"] = true;
      this.historical_strategy_columns[2]["tooltip"] = true;
      this.historical_strategy_columns[3]["tooltip"] = true;
      this.historical_strategy_columns[5]["minWidth"] = 130;
      this.historical_strategy_columns[5]["render"] = (h, params) => {
        return h("div", {
          style: {
              display: "flex",
              "justify-content": "space-around",
              "align-items": "center"
          }
        },[
          this.$createElement(
            "Button",
            {
              props: {
                type: "warning",
                size: "small",
                loading: false,
              },
              style: {

              },
              on: {
                click: () => {
                  this.create_or_alter_table_strategy_id = this.historical_strategy_data[params["index"]][0]
                  this.current_tabs_name = "name3"
                }
              }
            },
            "设置"
          )
        ]);
      };
      this.historical_strategy_columns[6]["render"] = (h, params) => {
        return h("div",[
          this.$createElement(
            "Button",
            {
              props: {
                type: "text",
                loading: false,
                size:"large",
                shape:"circle",
                icon:"md-trash",
              },
              style: {
                "font-size":"20px",
                "box-shadow":"none",
              },
              on: {
                click: () => {
                  // 将历史策略从前端展示中直接删除
                  var index = Number(this.historical_strategy_data[params["index"]][0])
                }
              },
            }
          )
        ]);
      };
    },
    supervisor_strategy_init_table_func: function() {
      // 初始化当前策略的表格
      const name_array = this.supervisor_strategy_array;
      this.supervisor_strategy_columns = [];
      for (var i = 0; i < name_array.length; i++) {
        this.supervisor_strategy_columns.push({
          title: name_array[i],
          key: name_array[i],
          tooltip:true,
          align: "center"
        })
      }
      // "账户编号", "方向","数量","下单标的","成本价",
      // "现价","止盈价","止损价","信息","未实现盈亏","执行进度"
      this.supervisor_strategy_columns[1]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        var color;
        if (buy_sell.indexOf("buy") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        if (buy_sell == "空仓") {
          color = "#000000";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.supervisor_strategy_columns[2]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]];
        var buy_sell = params["row"]["方向"].toLowerCase();
        var color;
        if (buy_sell.indexOf("buy") != -1) {
          color = "#006633";
        } else {
          color = "#ed4014";
        }
        if (buy_sell == "空仓") {
          color = "#000000";
        }
        return h("div", [
          h(
            "span",
            {
              style: {
                color: color,
              },
            },
            value
          ),
        ]);
      };
      this.supervisor_strategy_columns[4]["render"] = (h, params) => {
        var value = params["row"][params["column"]["key"]]
        return h("div", [
          h(
            "span",
            {
              style: {},
            },
            value
          ),
        ]);
      }
      this.supervisor_strategy_columns[9]["minWidth"] = 80
      this.supervisor_strategy_columns[10]["minWidth"] = 80
      this.supervisor_strategy_columns[10]["render"] = (h, params) => {
        var value = params["row"]["执行进度"];
        if (value[1] == 0) {
          var percent = 100;
        } else {
          var percent = Math.round((100 * value[0]) / value[1]);
        }
        return h("div", [
          this.$createElement("Progress", {
            props: {
              percent: percent,
              status: "active",
            },
            style: {},
            ref: "personal_drive_show_progress",
          }),
        ]);
      }

    },
    modal_click: function(value) {
      if (value["mode"] != "ok") {
        this.modal_view_msg["open_modal_switch"] = false
        return null
      }
      if (value["m_type"] === "strategy_msg") {
        // 用户单击了确认创建/修改按钮
        for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["type"] === "strategy_msg") {
              this.create_or_alter_table_msg[i]["paras"]["current_symbol"] = value["paras"]["current_symbol"]
              this.create_or_alter_table_msg[i]["paras"]["description"] = value["paras"]["description"]
              this.create_or_alter_table_msg[i]["paras"]["name"] = value["paras"]["name"]
              break
          }
        }
        // to do:根据创建新策略/修改既有策略的场景，将create_or_alter_table_msg传递到后台执行
        this.$Message.success('success');
      } else if (value["m_type"] === "select_strategy_msg"){
        this.create_or_alter_table_strategy_id = value["select_strategy"]["id"]
      } else {
        for (var i = 0; i < this.create_or_alter_table_msg.length; i++) {
          if (this.create_or_alter_table_msg[i]["uuid"] === value["uuid"]) {
              this.create_or_alter_table_msg[i]["paras"] = value["paras"]
              this.create_or_alter_table_msg[i]["execute_percent"] = value["execute_percent"]
              this.$Message.success('success');
              break
          }
        }
        // 重新渲染表格
        this.update_create_or_alter_table_msg()
      }
      this.modal_view_msg["open_modal_switch"] = false
    },
    get_uuid: function() {
      var d = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
      });
      return uuid;
    },
    check_account_msg: function(strategy_msg) {
      var acc_index = {}
      //对策略参数信息内的可执行账户进行鉴权、裁剪
      for (var i = 0; i < this.allow_msg["account_msg"].length; i++) {
        acc_index[this.allow_msg["account_msg"][i][0]] = this.allow_msg["account_msg"][i][1]
      }
      var new_strategy_msg = []
      var _strategy_msg = null
      for (var _strategy_index in strategy_msg) {
        _strategy_msg = strategy_msg[_strategy_index]
        if (_strategy_msg["type"] === "account_msg" && !(_strategy_msg["paras"][0] in acc_index)) {
            continue
        }
        else {
          new_strategy_msg.push(_strategy_msg)
        }
      }
      return this.account_msg_drop_duplicates(new_strategy_msg)
    },
    account_msg_drop_duplicates: function(strategy_msg) {
      // 对添加的账户户名进行去重
      var acc_index = {}
      var new_strategy_msg = []
      var _strategy_msg = null
      for (var _strategy_index in strategy_msg) {
        _strategy_msg = strategy_msg[_strategy_index]
        if (_strategy_msg["type"] != "account_msg") {
          new_strategy_msg.push(_strategy_msg)
        }
        else {
          if (_strategy_msg["paras"][0] in acc_index) {
            continue
          } else {
            new_strategy_msg.push(_strategy_msg)
            acc_index[_strategy_msg["paras"][0]] = 1
          }
        }
      }
      return new_strategy_msg
    },
    create_or_alter_table_get_strategy_msg: function(strategy_id) {
      // 从接口获得展示在前端界面上的策略参数信息
      return JSON.parse(JSON.stringify(this.all_strategy[strategy_id.toString()]))
    },
    create_or_alter_table_get_all_allow_msg: function() {
      // 从接口获得该登陆账户可以使用的所有账户、信号清单
      return {
        //账户使用 id,description 的形式
        "account_msg":[
          [1, "测试账户"],
          [3, "主账户"],
          [10, "小白的账户"],
        ],
        //信号使用 name,默认paras,解释说明 的形式
        "sign":[
          ["ma", [66, 490, 3, 'm', 'buy'], "MA均线信号"],
          ["ema", [66, 490, 3, 'm', 'buy'], "EMA均线信号"],
          ["price_judge", ['up', 10000, 'buy'], "限价追踪"],
          ["sign_price_drop_judge", ['up', 0.01, 'buy'], "冲高回落/超跌反弹追踪"],
          ["trigger_immediately", ['buy'], "立即触发"],
        ],
        // 固定项参数使用  name,默认参数, 解释说明的形式
        "default":[
          ["stop_loss", [0.03, 0.0], "固定止损(带推止损)"],
          ["stop_gain", [0.03], "固定止盈"],
        ]
      }
    },
    create_or_alter_table_get_all_strategy: function() {
      // 获取所有该登陆账户可以操作的策略详情
      return {
        "-1":[
          {"type":"sign","name":"ma","paras":[66,490,3,'m','buy'],"open_or_close":"open","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"sign","name":"ema","paras":[66,490,3,'m','buy'],"open_or_close":"open","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"sign","name":"price_judge","paras":['up',58000,'buy'],"open_or_close":"open","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"sign","name":"sign_price_drop_judge","paras":['up',0.01,'buy'],"open_or_close":"open","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"sign","name":"trigger_immediately","paras":['buy'],"open_or_close":"open","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"sign","name":"ema","paras":[66,490,3,'m','buy'],"open_or_close":"close","execute_percent":1,"uuid":this.get_uuid()},
          {"type":"function_type","name":"","open_or_close":"open","paras":[2],"uuid":this.get_uuid()},
          {"type":"function_type","name":"","open_or_close":"close","paras":[2],"uuid":this.get_uuid()},
          {"type":"default","name":"stop_loss","open_or_close":"close","execute_percent":1,"paras":[0.03,-0.03],"uuid":this.get_uuid()},
          {"type":"default","name":"stop_gain","open_or_close":"close","execute_percent":0.5,"paras":[0.03],"uuid":this.get_uuid()},
          {"type":"default","name":"stop_gain","open_or_close":"close","execute_percent":1,"paras":[0.05],"uuid":this.get_uuid()},
          {"type":"account_msg","name":"","description":"测试账户1","paras":[1,0.1],"uuid":this.get_uuid()},
          {"type":"account_msg","name":"","description":"主账户1","paras":[3,0.3],"uuid":this.get_uuid()},
          {"type":"account_msg","name":"","description":"小白的账户","paras":[10,0.5],"uuid":this.get_uuid()},
          {"type":"account_msg","name":"","description":"主账户2","paras":[6,0.5],"uuid":this.get_uuid()},
          {"type":"strategy_msg","paras":{
              "name":"初始化策略",
              //有效的symbol列表
              "symbol_list":["btcusdt","ethusdt","bnbusdt"],
              //0:待启动1:正在运行2:历史策略
              "current_status_code":0,
              //当前策略选择的标的
              "current_symbol":"btcusdt",
              //启动次数
              "run_count":0,
              //策略上次更新的时间
              "last_update_datetime":"2021-05-2412:01:01",
              "description":"策略补充说明信息"},
              'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'strategy_msg_uuid'
          }
        ],
        "13":[
            {'type': 'sign', 'name': 'ma', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '8'}, 
            {'type': 'sign', 'name': 'sign_price_drop_judge', 'paras': ['up', 0.1, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '11'},
            {'type': 'sign', 'name': 'ema', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '7'}, 
            {'type': 'sign', 'name': 'price_judge', 'paras': ['up', 10000, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '6'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'open', 'paras': [2], 'uuid': '5'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'close', 'paras': [1], 'uuid': '4'}, 
            {'type': 'default', 'name': 'stop_loss', 'open_or_close': 'close', 'paras': [0.13, 0.1], "execute_percent":1, 'uuid': '3'}, 
            {'type': 'default', 'name': 'stop_gain', 'open_or_close': 'close', 'paras': [0.1], "execute_percent":1, 'uuid': '2'}, 
            {'type': 'account_msg', 'name': '', "description":"测试账户1", 'paras': [1, 0.8], 'uuid': '1'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['sell'], 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'xxx11111'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': 'xxx112'},
            {'type': 'strategy_msg', 'paras': {
                'name': '灵活策略1',
                // 有效的symbol列表
                "symbol_list":["btcusdt", "ethusdt", "bnbusdt"],
                // 0:待启动 1:正在运行 2:历史策略 3:已删除
                "current_status_code":0,
                // 当前策略选择的标的
                "current_symbol":"btcusdt",
                // 启动次数
                "run_count":0,
                // 策略上次更新的时间
                "last_update_datetime":"2021-05-24 12:01:01",
                "description":"策略补充说明信息1"
              }, 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'strategy_msg_uuid'}
           ],
        "15":[
            {'type': 'sign', 'name': 'ma', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '8'}, 
            {'type': 'sign', 'name': 'sign_price_drop_judge', 'paras': ['up', 0.1, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '11'},
            {'type': 'sign', 'name': 'ema', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '7'}, 
            {'type': 'sign', 'name': 'price_judge', 'paras': ['up', 10000, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '6'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'open', 'paras': [2], 'uuid': '5'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'close', 'paras': [1], 'uuid': '4'}, 
            {'type': 'default', 'name': 'stop_loss', 'open_or_close': 'close', 'paras': [0.15, 0.1], "execute_percent":1, 'uuid': '3'}, 
            {'type': 'default', 'name': 'stop_gain', 'open_or_close': 'close', 'paras': [0.1], "execute_percent":1, 'uuid': '2'}, 
            {'type': 'account_msg', 'name': '',"description":"测试账户1", 'paras': [1, 0.8], 'uuid': '1'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['sell'], 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'xxx11111'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': 'xxx112'},
            {'type': 'strategy_msg', 'paras': {
                'name': '灵活策略2',
                // 有效的symbol列表
                "symbol_list":["btcusdt", "ethusdt", "bnbusdt"],
                // 0:待启动 1:正在运行 2:历史策略
                "current_status_code":1,
                // 当前策略选择的标的
                "current_symbol":"btcusdt",
                // 启动次数
                "run_count":0,
                // 策略上次更新的时间
                "last_update_datetime":"2021-05-24 12:01:01",
                "description":"策略补充说明信息2"
              }, 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'strategy_msg'}
           ],
          "18":[
            {'type': 'sign', 'name': 'ma', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '8'}, 
            {'type': 'sign', 'name': 'sign_price_drop_judge', 'paras': ['up', 0.1, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '11'},
            {'type': 'sign', 'name': 'ema', 'paras': [66, 490, 3, 'm', 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '7'}, 
            {'type': 'sign', 'name': 'price_judge', 'paras': ['up', 10000, 'buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': '6'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'open', 'paras': [2], 'uuid': '5'}, 
            {'type': 'function_type', 'name': '', 'open_or_close': 'close', 'paras': [0], 'uuid': '4'}, 
            {'type': 'default', 'name': 'stop_loss', 'open_or_close': 'close', 'paras': [0.18, 0.1], "execute_percent":1, 'uuid': '3'}, 
            {'type': 'default', 'name': 'stop_gain', 'open_or_close': 'close', 'paras': [0.1], "execute_percent":1, 'uuid': '2'}, 
            {'type': 'account_msg', 'name': '', "description":"测试账户1", 'paras': [1, 0.8], 'uuid': '1'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['sell'], 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'xxx11111'}, 
            {'type': 'sign', 'name': 'trigger_immediately', 'paras': ['buy'], 'open_or_close': 'open', 'execute_percent': 1, 'uuid': 'xxx112'},
            {'type': 'strategy_msg', 'paras': {
                'name': '灵活策略3',
                // 有效的symbol列表
                "symbol_list":["btcusdt", "ethusdt", "bnbusdt"],
                // 0:待启动 1:正在运行 2:历史策略
                "current_status_code":2,
                // 当前策略选择的标的
                "current_symbol":"btcusdt",
                // 启动次数
                "run_count":0,
                // 策略上次更新的时间
                "last_update_datetime":"2021-05-24 12:01:01",
                "description":"策略补充说明信息2"
              }, 'open_or_close': 'close', 'execute_percent': 1, 'uuid': 'strategy_msg'}
           ],
      }
    },
    supervisor_strategy_get_msg: function() {
      // 从接口获得当前被监控策略的最新状态,
      // 当前选择的是supervisor_strategy_id
      if (this.supervisor_strategy_id.toString() == "-1") {
        return []
      }
      // "账户编号", "方向","数量","下单标的","成本价",
      // "现价","止盈价","止损价","信息","未实现盈亏","执行进度"
      return [
        [1, "Buy", "1.34", "btcusdt", "45778.67", 56000.77, 58000.37, 43000.44, 
        "开启了\n关闭了\n由MA指标触发了一次开仓\n", "2743.77 USDT", [0, 0]],
        [2, "Buy", "1.34", "btcusdt", "45778.67", 56000.77, 58000.37, 43000.44, 
        "开启了\n关闭了\n由MA指标触发了一次开仓\n", "2743.77 USDT", [1000, 1000]],
      ]
    },
    loop_update_supervisor_strategy: function() {
      // 根据现在用户打开的界面+倒计时情况,判断是否需要刷新一次监控界面
      if (this.current_tabs_name != "name4" || this.supervisor_strategy_id.toString() === "-1" || 
          this.loop_update_supervisor_button_loading === true) {
        return null
      }
      if (this.loop_update_supervisor_strategy_time_count > 0) {
        this.loop_update_supervisor_strategy_time_count -= 1
      } else {
        // 每5秒刷新一次
        this.loop_update_supervisor_strategy_time_count = 5
        this.loop_update_supervisor_button_click()
      }
    },
    loop_update_supervisor_button_click: function() {
      // 刷新按钮被单击，刷新一次监控项
      this.loop_update_supervisor_button_loading = true
      this.update_supervisor_strategy_table_msg()
      this.loop_update_supervisor_button_loading = false
    },
    setTimer: function(interval, timer) {
      if (timer == null) {
        timer = setInterval(() => {
          this.loop_update_supervisor_strategy()
        }, interval);
      }
    },
    current_strategy_table_start_click: function(str_id) {
      // 当前策略页面中，单击了开始按钮
      var msg = this.all_strategy[str_id]
      var strategy_msg = this.get_strategy_msg(msg)
      if (strategy_msg["paras"]["current_status_code"].toString() != "0") {
        console.log("wrong status_code in start func")
        return null
      }
      //to do: 调用API拉起策略
    },
    current_strategy_table_end_click: function(str_id) {
      // 当前策略页面中，单击了关闭按钮
      var msg = this.all_strategy[str_id]
      var strategy_msg = this.get_strategy_msg(msg)
      if (strategy_msg["paras"]["current_status_code"].toString() != "1") {
        console.log("wrong status_code in end func")
        return null
      }
      //to do: 调用API关闭策略
    },
    set_strategy_status_code: function(status_code, strategy_id) {
      // status_code==0:历史策略变为待启动
      // status_code==2:待启动策略变为历史策略
      // 设置策略的status_code，设计初用于在当前策略/历史策略的删除按钮上
      // 更改策略的执行状态，由代启动变为历史策略，或者由历史策略变为待启动策略
      
      //to do: 调用API修改策略状态
    }
  },
  mounted() {
    this.all_strategy = this.create_or_alter_table_get_all_strategy()
    this.allow_msg = this.create_or_alter_table_get_all_allow_msg()
    this.update_strategy_table_msg()

    var str = {
    "uid":"1223334",
    "pwd":"asd"
    };
    var encrypted = this.$getRsaCode(JSON.stringify(str))
    console.log('加密前数据:%o', str);
    console.log('加密后数据:%o', encrypted);
  },
  watch: {
    create_or_alter_table_strategy_id(old_value) {
      var new_id = this.create_or_alter_table_strategy_id.toString()
      if (new_id == "-1") {
        this.create_or_alter_table_title = "创建新策略"
        this.create_or_alter_table_button_title = "确认创建"
      } else {
        this.create_or_alter_table_title = "修改".concat(new_id, "号策略")
        this.create_or_alter_table_button_title = "确认修改"
      }
      this.create_or_alter_table_click_3()
    },
    supervisor_strategy_id(old_value) {
      // 用户单击了选择录入策略ID的选择框
      this.update_supervisor_strategy_table_msg()
      this.supervisor_strategy_drop_down_title = this.supervisor_strategy_id + "号策略"
    }
  },
  beforeMount: function() {},
  created: function() {
    clearInterval(this.timer);
    this.timer = null;
    this.setTimer(1000, this.timer);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style>
.ivu-table td.test-class {
  flex-wrap: nowrap;
  justify-content: space-between;
  display: "flex";
  align-items:"center"
}
</style>

<style scoped>
.demo-drawer-hearde {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  text-align: right;
  background: #fff;
}
</style>